import { GerenciadorIntermediariasBase } from '@/domain/simulador/gerenciador-intermediarias-base'

export class GerenciadorIntermediariasSacocH extends GerenciadorIntermediariasBase {
  hasParcelasAposUltimaMensal(datasIntermediarias: string[], dataUltimaMensal?: string | null): boolean {
    if (!dataUltimaMensal || !datasIntermediarias.length) return false

    const dataUltimaMensalObj = new Date(dataUltimaMensal)
    return datasIntermediarias.some((dataIntermediaria) => {
      return new Date(dataIntermediaria) > dataUltimaMensalObj
    })
  }
}
